import { useState, useEffect, useRef } from "react"
import { Editor } from "@tinymce/tinymce-react"
import PropTypes from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import { editBlock, editBlockText, editBlockClean } from "../../store/actions"
import { addImage } from "../../helpers/backend_helper"

const CoursesLesonnsFormWysiwyg = props => {
  const dispatch = useDispatch()

  const { blockEditText } = useSelector(store => ({
    blockEditText: store.BlockEdit.text,
  }))

  const block = props.block
  const element = blockEditText.find(text => text.key === block.idBlock)

  const saveBlock = () => {
    const element = blockEditText.find(text => text.key === block.idBlock)
    const value = element === undefined ? "" : element.value
    if (value !== "") {
      const request = {
        ...block,
        value,
      }
      dispatch(editBlock(request))
    }
  }

  useEffect(() => {
    return () => {
      saveBlock()
    }
  }, [])

  return (
    <Editor
      apiKey={"9p7bo3vgmi2do9q72hi0eoj0e2rmvk8t84q83qyd66hu2qa3"}
      initialValue={block.value}
      init={{
        menubar: "file edit view insert format table help",
        selector: "textarea#full-featured",
        plugins:
          "print preview importcss tinydrive searchreplace autolink autosave save \
          directionality visualblocks visualchars fullscreen image link media template \
          codesample table charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists \
          wordcount imagetools textpattern noneditable help \
          charmap quickbars emoticons",
        toolbar:
          "undo redo | fontselect fontsizeselect formatselect | bold italic underline strikethrough | \
            alignleft aligncenter alignright alignjustify | \
            bullist numlist checklist outdent indent | \
            forecolor backcolor casechange permanentpen formatpainter removeformat | \
            pagebreak | charmap emoticons | fullscreen  preview save print | \
            image media pageembed link anchor codesample | \
            a11ycheck | help",
        toolbar_mode: "sliding",
        content_style: ".mymention{ color: gray; }",
        contextmenu: "link image imagetools table configurepermanentpen",
        a11y_advanced_options: true,
        image_uploadtab: true,
        skin: "oxide",
        content_css: "default",
        template_cdate_format: "[Creado el (CDATE): %d/%m/%Y : %H:%M:%S]",
        template_mdate_format: "[Editado el (MDATE): %d/%m/%Y : %H:%M:%S]",
        height: 600,
        images_upload_handler: async function (blobInfo, success, failure) {
          const formData = new FormData()
          formData.append("file", blobInfo.blob())
          try {
            const response = await addImage(formData)
            success(response[0])
          } catch (error) {
            return
          }
        },
      }}
      onChange={e => {
        dispatch(editBlockText(block.idBlock, e.target.getContent()))
      }}
      onBlur={() => saveBlock()}
    />
  )
}

CoursesLesonnsFormWysiwyg.propTypes = {
  block: PropTypes.object,
}

export default CoursesLesonnsFormWysiwyg
